import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export function CTASection({
  title = "Ready For A Floor That Lasts?",
  body = "Get a free, no-pressure quote from Calgary's premium epoxy flooring specialists.",
  variant = "dark",
}: { title?: string; body?: string; variant?: "dark" | "light" }) {
  const wrap = variant === "light" ? "section-light bg-bone" : "bg-charcoal";
  return (
    <section className={`relative isolate overflow-hidden border-y border-border ${wrap}`}>

      <div className="absolute inset-0 grain opacity-60" aria-hidden />
      <div className="container-x relative py-16 md:py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="max-w-xl">
          <span className="copper-rule mb-5" />
          <h2 className="text-3xl md:text-4xl text-silver-light">{title}</h2>
          <p className="mt-3 text-silver text-base md:text-lg max-w-prose">{body}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <Link
            to="/quote"
            className="inline-flex items-center justify-center rounded-sm bg-copper px-7 py-4 text-sm font-bold uppercase tracking-wider text-white hover:bg-copper-hover transition-colors"
          >
            Get Free Quote
          </Link>
          <a
            href={SITE.phoneHref}
            className="inline-flex items-center justify-center gap-2 rounded-sm border border-silver/40 px-7 py-4 text-sm font-bold uppercase tracking-wider text-silver-light hover:border-copper hover:text-copper transition-colors"
          >
            <Phone className="h-4 w-4" /> {SITE.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
